'use strict';
declare var _emiapi: any;
declare var _emiapiforbanks: any;
declare var _emisubdomain: any;
declare var _emiwww: any;
export var version: string ="0.1";

export var _emisubdomainUrl:string ="http://" + _emisubdomain;

export var _emi1ApiUrl:string ="http://operations.ehomeloan.co.in/api/v1";
// export var _emi1ApiUrl:string ="http://operations.emi.dev/api/v1";

export const PersonalLoan_New: string ="Personal Loan";
export const PersonalLoan_Transfer: string ="Personal Loan Transfer";
export const HomeLoan_New: string ="Home Loan";
export const HomeLoan_Transfer: string ="Home Loan Transfer";
export var pageInfo:string ="pageInfo";
export var portalInfo:string ="portalInfo";
export var portalMenu:string ="portalMenu";
export var PortalCity ="PortalCity";
export var PortalBank_Filter ="PortalBank_Filter";
export var Home_loan_PortalBank_Filter ="PortalBank_Filter_home";
export var Personal_loanPortalBank_Filter ="PortalBank_Filter_personal";
export var PortalBank ="PortalBank";
export var agentInfo:string ="agentInfo";
export var pageTestimonials:string ="pageTestimonials";

//URL    

export var getLeadByIdUrl: string    ="https://"+_emiapi + "/v1/getLeadById"; 
export var portalInfoUrl: string    ="https://"+_emiapi + "/v1/portal/basic-info"; 

export var pageInfoUrl: string      ="https://" + _emiapi + "/v1/portal/page-info/"; //Deprecated

export var pageInfoByUrl: string      ="https://" + _emiapi + "/v1/portal/page-info-from-url";  
export var productListByUrl: string      ="https://" + _emiapi + "/v1/portal/product-list-from-url"; 

export var jwtTokenUrl: string      ="https://" + _emisubdomain + "/api/v1/auth/portal";  
export var commonLeadUrl: string    ='https://' + _emiapi + '/v1/leads/submit-data';   

// export var companySpecificUrl: string   ='api.eemi.dev/v1/v1/company-specific-offers/';
// export var companyListUrl: string       ='api.eemi.dev/v1/company-groups';

export var companySpecificUrl: string   ='https://' + _emiapi + '/v1/company-specific-offers/';
export var companyListUrl: string       ='https://' + _emiapi + '/v1/company-groups';

// export var companySpecificUrl: string   =_emi1ApiUrl + '/company-specific-offers/';
// export var companyListUrl: string       =_emi1ApiUrl + '/special-company-list';

export var allcompanyList: string ='https://' + _emiapi + '/v1/loan/all-company-list';
export var addNewCompany: string ='https://' + _emiapi + '/v1/portal/add-company';
export var customCompanyOffers: string ='https://' + _emiapi + '/v1/company/offers';
export var customCompanyProductOffers: string ='https://' + _emiapi + '/v1/portal/product-list-by-id';


export var bankList: string       ='https://' + _emiapi +'/v1/all-bank-list';
export var bankSpecficUrl: string       ='https://' + _emiapi +'/v1/all-bank-list';

//bank cutome-products
export var bankcustomCompanyOffers: string ='https://' + _emiapi + '/v1/bank/offers';
export var bankcustomCompanyProducts: string ='https://' + _emiapi + '/v1/portal/product-list-by-id';

//realestate module API
export var builderprojectnamelocalityonsearch: string ='https  ://' + _emiapi + '/v1/serach';
export var builderProjectDetailsOnsearch: string ='https://' + _emiapi + '/v1/input/result';
export var postProperty: string ='https://' + _emiapi + '/v1/save-property';

//advance-property-search
export var AdvancepropertySearch:string='https://' + _emiapi + '/v1/property/search/result';
//real-estate get user projects
export var getUserProjects:string ='https://' + _emiapi + '/v1/get/user-project';
//real-estate get project details
export var propertyDetails:string='https://' + _emiapi + '/v1/get/project-details';
//real-estate save-details

export var PostPropertyDetails:string='https://' + _emiapi + '/v1/real-estate/project-data';
//real-estate approval legal documment
export var uploadlegalDocunment='https://' + _emiapi + '/v1/upload-legal/document';
export var deleteUploadlegalDocunment='https://' + _emiapi + '/v1/delete/upload-legal/document';
//relestate cutomer-login

export var userLogin="https://" + _emisubdomain + "/api/v1/auth/users";
export var signup   ="https://" + _emiapi + '/v1/store/users';
export var userdetails   ="https://" + _emiapi + '/v1/get/users';

//real-estatate subscribe and unsubscibe properies

export var subscibeProperties ="https://" + _emiapi + '/v1/subscribe-properties';
export var propertyMappingUrl= "https://" + _emiapi + '/v1/property-mapping';
export var builderPropertyMappingUrl= "https://" + _emiapi + '/v1/builder/property-mapping';
export var subscribedProperties = "https://" + _emiapi + '/v1/subscribed-properties';
export var unSubscribePropertiesUrl = "https://" + _emiapi + '/v1/unsubscribed-properties';
export var unSubscribeBuilderPropertiesUrl = "https://" + _emiapi + '/v1/builder/unsubscribed-properties';

//real-estate delete gallery-images

export var DeleteGalleryImages:string='https://' + _emiapi + '/v1/delete-images';

//real-estate default portal_properties

export var DefaultPortalProperties:string = 'https://' + _emiapi + '/v1/default-properties';
//real-estate simple form submission

export var SimpleFormSubmission: string = 'https://' + _emiapi+ '/v1/real-estate/simple-form-data/collect';
export var getSimplePropertyById: string = 'https://' + _emiapi+ '/v1/get-property/';

export var persoanlLoanUrl:string   ='https://' + _emiapi + '/v1/loan/personal';
export var homeLoanUrl:string       ='https://' + _emiapi + '/v1/loan/home';
export var persoanlLoanDefaultOfferUrl:string   ='https://' + _emiapi + '/v1/loan/personal/offer/default';
export var homeLoanDefaultOfferUrl:string       ='https://' + _emiapi + '/v1/loan/home/offer/default';
export var persoanlCompaniesList:string        ='https://' + _emiapi + '/v1/loan/personal/companylist';
// export var persoanlCompaniesList:string        ='https  ://ehomeloan.co.in/emi/getplcompanylist.php';
export var personalCompanyListByUrl:string    = 'https://ehomeloan.co.in/emi/api/other/companylistbyurl.php';
export var homeCompaniesList:string       ='https://ehomeloan.co.in/emi/gethlcompanylist.php';
export var insuranceProductsUrl: string ='https://' + _emiapi + '/v1/insurance/products/';

export var highlightsUrl: string ='https://' + _emiapi + '/v1/getHighlights';
export var deleteHighlightsUrl: string = 'https://' + _emiapi + '/v1/delete-highlights';

export var getapprovalMoreDetails: string ='https://' + _emiapi + '/v1/getbaknschme-othertechnical-legal';
export var deleteBankScheme: string ='https://' + _emiapi + '/v1/delete-bankscheme';
export var deleteOtherApproval: string ='https://' + _emiapi + '/v1/delete-technicalapproval';

export const getUnitVideos  = 'https://' + _emiapi + '/v1/getunit_videos';
export const getGalleryVideo  = 'https://' + _emiapi + '/v1/getgallery_videos';
export const deleteUnitVideo  = 'https://' + _emiapi + '/v1/delete-unit_video';
export const deleteGalleryVideo  = 'https://' + _emiapi + '/v1/delete-gallery_video';
export const deletePropertyAmenities = 'https://' + _emiapi + '/v1/delete-property_amenities';

export const uploadLeadUrl  = 'https://' + _emiapi + '/v1/uploadLead';

//builder API

export var builderSpecificUrl='https://' + _emiapi + '/v1/builder/';
export var builderSpecificUrlGlobal='https://' + _emiapi + '/v1/builder/globally/';
export var builderOngoingProjectUrl='https://' + _emiapi + '/v1/builder/ongoing/';
export var builderCompletedProjectUrl='https://' + _emiapi + '/v1/builder/completed/';
export var builderFutureProjectUrl='https://' + _emiapi + '/v1/builder/future/';
export var builderProjectSpecificUrl='https://' + _emiapi + '/v1/builder/projects_details/';
export var builderLeadSubmit='https://' + _emiapi + '/v1/builder-lead';

export var builderSpecificLeadSubmit='https://' + _emiapi + '/v1/specific/builder-lead';

export var PropertyAgentCreation='https://' + _emiapi + '/v1/create/profile';

export var ProjectCostEmiSavings='https://' + _emiapi + '/v1/get/cost-loan-terms';
export var PropertyPaymentTerms='https://' + _emiapi + '/v1/get/property-payment-terms';




//bank-logo

// export var bankdetails='httpss://' + _emiapi + '/v1/banks';

export var bankdetails='https://' + _emiapi + '/v1/portal-banks';
export var bankdetailsPersonalLoan='https://' + _emiapi + '/v1/personal-loan/portal-banks';


export var homeProductsList:string       ='https://' + _emiapi + '/v1/portal/home-products';


export var realEstateAwardsAndBlogsList = 'https://' + _emiapi + '/v1/get/getRealEstateAwardsAndBlogs';
//Local Variable

export var leadType = { 
    "HomeLoan"      : "home_loan",
    "PersonalLoan"  : "personal_loan",
    "CallBack"      : "call_back",
    "SaveSalary"    : "save_salary",
    "InsuranceLife" : "insurance_life",
    "InsuranceHealth": "insurance_health",
    "InsuranceTerm" : "insurance_term",
    "life" : "insurance_life",
    "health": "insurance_health",
    "term" : "insurance_term",
};

// credit API 

export const creditUrl = 'https://' + 'eportuat.equifax.co.in/cir360Report/cir360Report';
// calculator API

//export const productQuestionUrl = 'https://' + _emiapi + '/v1/productQuestions'; // commented by MMP

export const productQuestionUrl = 'https://' + _emisubdomain + '/v1/productQuestions'; // copied by MMP


export const questionUrl = 'https://' + _emiapi + '/v1/question';
export const optionUrl = 'https://' + _emiapi + '/v1/options';
export const statusUrl = 'https://' + _emiapi + '/v1/status';
export const subQuestionDropdownUrl = 'https://' + _emiapi + '/v1/dropdowns';
export const productByUrlCategory = 'https://' +_emiapi + '/v1/getProductByUrlCategory';
export const mainProductByUrlCategory = 'https://' +_emiapi + '/v1/getMainProductByUrlCategory';
export const productById = 'https://' +_emiapi + '/v1/subProductByProductId';
export const productOfferForWithdraw = 'https://' +_emiapi + '/v1/productOfferForWithdraw';
export const bankListsUrl = 'https://' +_emiapi + '/v1/getAllBanks';


// Company Specific Offer API

export const productOfferUrl = 'https://' + _emiapi + '/v1/productOffer';
export const productOfferForPartPaymentUrl = 'https://' + _emiapi + '/v1/productOfferForPartPayment';
export const balanceTransferUrl = 'https://' + _emiapi + '/v1/productOfferForBalanceTransfer';
export const partPaymentByReducedEmiUrl = 'https://' + _emiapi + '/v1/productOfferForPartPaymentToChangeEmi';
export const changeInRateUrl = 'https://' + _emiapi + '/v1/changeInRate';
export const companyBankListUrl = 'https://' + _emiapi + '/v1/companyList';
export const companySpecificOfferUrl = 'https://' + _emiapi + '/v1/companyspecificOffer';
export const loanEligibiltyUrl = 'https://' + _emiapi + '/v1/loaneligibility';
export const PartPaymentUrl = 'https://' + _emiapi + '/v1/partPayment';
export const amoritizationtUrl = 'https://' + _emiapi + '/v1/amortization';
export const recurringPartPaymentUrl = 'https://' + _emiapi + '/v1/recurringPartPayment';
export const saveToLeadUrl = 'https://' + _emiapi + '/v1/loan-lead';
export const leadOfferUrl = 'https://' + _emiapi + '/v1/leadOffer';
export const defaultOfferUrl = 'https://' + _emiapi + '/v1/defaultOffer';
export const productUploadUrl = 'https://' + _emiapi + '/v1/subProductUpload';
export const getBankListUrl = 'https://' + _emiapi + '/v1/getBankList';
export const getLeadDetailsById = 'https://' + _emiapi + '/v1/getLeadDetailsById';





// company specific page API

// export const companyList: string       = _emi1ApiUrl + '/company-groups';
// export const productsBasedOnCompanyGroup: string = _emi1ApiUrl + '/getAllProductsByGroupId';
export const companyList: string       = 'https://' + _emiapi + '/v1/company-group';
export const productsBasedOnCompanyGroup: string = 'https://'  + _emiapi + '/v1/getAllProductsByGroupId';
export const companyListByBankId: string       = 'https://' + _emiapi + '/v1/company-list';
export const productsByBankId: string       = 'https://' + _emiapi + '/v1/productsByBankId';



// Loan Enums

export var SalaryBankEnum = [
    { value: '1', name: 'AXIS BANK' },
    { value: '2', name: 'CITI BANK' },
    { value: '3', name: 'KOTAK MAHINDRA' },
    { value: '4', name: 'HDFC BANK' },
    { value: '5', name: 'ICICI BANK' },
    { value: '7', name: 'SBI' },
    { value: '16', name: 'SCB' },
    { value: '17', name: 'HSBC' },
    { value: '27', name: 'BANK OF BARODA' },
    { value: '26', name: 'IDFC BANK' },
    { value: '11', name: 'YES BANK' },
    { value: '0', name: 'Others' },
];
export var GenderEnum = [
    { value: '1', name: 'Male' },
    { value: '3', name: 'Female' },
    { value: '2', name: 'Others' },

];
export var WorkExperienceEnum = [
    { value: '1', name: 'Work Experience<1 Year' },
    { value: '2', name: 'Work Experience >1 Year' },
    { value: '3', name: 'Work Experience >2 Years' },
    { value: '4', name: 'Work Experience >3 Years' }

];
export var LocationEnum = [
    { value: '1', name: 'Bengaluru' },
    { value: '2', name: 'Mysuru' },
    { value: '3', name: 'Mumbai' },
    { value: '4', name: 'Pune' },
    { value: '5', name: 'Hyderabad' },
    { value: '6', name: 'Mumbai' },
    { value: '7', name: 'Gurugram' },
    { value: '8', name: 'Kochi' },
];

export var HLLoanTenureEnum = [
    { value: '3', name: '3 Years' },
    { value: '4', name: '4 Years' },
    { value: '5', name: '5 Years' },
    { value: '6', name: '6 Years' },
    { value: '7', name: '7 Years' },
    { value: '8', name: '8 Years' },
    { value: '9', name: '9 Years' },
    { value: '10', name: '10 Years' },
    { value: '11', name: '11 Years' },
    { value: '12', name: '12 Years' },
    { value: '13', name: '13 Years' },
    { value: '14', name: '14 Years' },
    { value: '15', name: '15 Years' },
    { value: '16', name: '16 Years' },
    { value: '17', name: '17 Years' },
    { value: '18', name: '18 Years' },
    { value: '19', name: '19 Years' },
    { value: '20', name: '20 Years' },
    { value: '21', name: '21 Years' },
    { value: '22', name: '22 Years' },
    { value: '23', name: '23 Years' },
    { value: '24', name: '24 Years' },
    { value: '25', name: '25 Years' },
    { value: '26', name: '26 Years' },
    { value: '27', name: '27 Years' },
    { value: '28', name: '28 Years' },
    { value: '29', name: '29 Years' },
    { value: '30', name: '30 Years' }
];

export var PLLoanTenureEnum = [
    { value: '1', name: '1 Years' },
    { value: '2', name: '2 Years' },
    { value: '3', name: '3 Years' },
    { value: '4', name: '4 Years' },
    { value: '5', name: '5 Years' }
];

export var HLEmploymentTypeEnum = [
    { value: '1', name: 'Salaried' },
    { value: '2', name: 'NRI Salaried' },
    { value: '3', name: 'Self Employed-Doctors' },
    { value: '4', name: 'Self Employed-Professional' },
    { value: '5', name: 'Self Employed-Others' }
];

export var PersonalEmployementList = [
    { value: '1', name: 'Salaried' },
    { value: '6', name: 'Salaried Doctors' },
    { value: '5', name: 'NRI Salaried' },
    { value: '2', name: 'Self Employed-Doctors' },
    { value: '3', name: 'Self Employed-Professional' },
    { value: '4', name: 'Self Employed-Others' }
];

export enum InputType {
    text = 1,
    button = 2,
    date = 3,
    radio = 4,
    image = 5,
    location = 6,
    ratings = 7,
    cards = 8,
    redirect = 9,
    checkbox = 10,
    video = 11
  }

  export enum InputTypeValidation {
      name = 1,
      number = 2,
      email = 3,
      mobile = 4,
      mobileTenDigits = 5,
      address = 6,
      password= 7
  }

  export enum QuestionCategory {
      age = 1,
      loanAmount = 2,
      tenure = 3,
      salary = 4,
      company = 10,
      city = 12,
      gender = 13,
      salaryAccountBank = 14,
      residencyId = 16,
      emi = 9
  }



// WEBPACK FOOTER //
// ./src/app/globals.ts